export default __webpack_public_path__ + "static/media/arrow-up-filled.0ec34ff3.svg";